import React, { useEffect, useState, useContext } from "react";
import {
  Box,
  Typography,
  TextField,
  Select,
  MenuItem,
  Button,
  FormControl,
  FormHelperText,
  Autocomplete,
} from "@mui/material";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import API_URLS from "../../../constants/apiConstants";
import "../css/InfoCard.css";
import { useTranslation } from "react-i18next";
import ParentModal from "./ParentModal";
import AuthContext from "../../../context/AuthProvider";
//import toast from 'react-hot-toast';
import { toast } from 'react-toastify';
const InfoCard = ({
  title,
  data: initialData,
  editable,
  id,
  type,
  handleEdit,
  onSaveSuccess,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [data, setData] = useState(initialData);
  const [tempData, setTempData] = useState(initialData);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});
  const [showModal, setShowModal] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const { t, i18n } = useTranslation();
  const isAr = i18n.language === 'ar';
  const { school, auth } = useContext(AuthContext);
  const [parentModalOpen, setParentModalOpen] = useState(false);
  const [parentModalData, setParentModalData] = useState(null);
  const [modalMode, setModalMode] = useState("add");

  useEffect(() => {
    // Keep the card UI in sync with new props (e.g., after a save completes).
    if (!isEditing) {
      setData(initialData);
      setTempData(initialData);
    }
  }, [initialData, isEditing]);

  const stdMapper = {
    "First Name": "FirstName", 
    "Last Name": "LastName",
    Name: "FirstName",
    Country: "countries",
    "Doctor Name": "DoctorName",
    "Doctor Phone No.": "DoctorPhone",
    Status: "StudentsStatus",
    "Meal Type": "MealType",
    Appartment: "AppartmentHouse",
    "Zip Code": "ZipCode",
    "Student ID": "student_id",
  };

  const staffMapper = {
    "First Name": "FirstName", 
    "Last Name": "LastName",
    Name: "FirstName",
    Country: "countries",
    "Doctor Name": "DoctorName",
    "Doctor Phone No.": "DoctorPhone",
    Status: "StatusStaff",
    Appartment: "AppartmentHouse",
    "Zip Code": "ZipCode",
    Email: "email",
    Gender: "gender_id",
    "Employment Notes": "EmpNotes",
    "Hire Date": "EmpHireDate",
    "Emergency Name": "EmergencyContactFirstName",
    "Emergency Type": "EmergencyContactType",
    "Emergency Phone": "EmergencyContactPhone",
    Certificate: "CertCertification",
    "Child Education Credits": "CertChildEduCredits",
    "Infant Toddler Credits": "CertInfantToddlerCredits",
    "Certificate Notes": "CertNotes",
  };

  const schoolMapper = {
    "Program Type": "ProgramType",
    Country: "countries",
  };
  // const getDifferences = () => {
  //   const mapp =
  //     type === "student"
  //       ? stdMapper
  //       : type === "staff"
  //       ? staffMapper
  //       : schoolMapper;
  //   return tempData.reduce((acc, item, index) => {
  //     const { label, value } = item;
  //     const original = initialData[index];
  //     if (Array.isArray(value)) {
  //       acc[label] = value.filter((i) => i !== -1);
  //     }
  //     if (value !== original?.value) {
  //       if (type === "staff" && label === "Name") {
  //         const [firstName = "", ...rest] = value.trim().split(/\s+/);
  //         acc["FirstName"] = firstName;
  //         acc["LastName"] = rest.join(" ");
  //       } else {
  //         const mappedLabel = mapp[label] || label;
  //         acc[mappedLabel] = value;
  //       }
  //     }
  //     return acc;
  //   }, {});
  // };

 const getDifferences = () => {
  const mapp =
    type === "student"
      ? stdMapper
      : type === "staff"
      ? staffMapper
      : schoolMapper;

  return tempData.reduce((acc, item, index) => {
    const { label, value } = item;
    const original = initialData[index];

    if (Array.isArray(value)) {
      // Only keep valid IDs for multi-select (e.g., Parents)
      const filtered = value.filter((v) => v !== -1 && v !== null);
      if (JSON.stringify(filtered) !== JSON.stringify(original?.value?.filter((v) => v !== -1 && v !== null))) {
        acc[label] = filtered;
      }
    } else if (value !== original?.value) {
      if (label === "Name") {
        const [firstName = "", ...rest] = value.trim().split(/\s+/);
        acc["FirstName"] = firstName;
        acc["LastName"] = rest.join(" ");
      } else {
        const mappedLabel = mapp[label] || label;
        acc[mappedLabel] = value;
      }
    }

    return acc;
  }, {});
};

  const validateSchoolFields = () => {
    if (type !== "school") return {};

    const errors = {};
    const phoneRegex = /^\+?\d{7,15}$/;
    const getValue = (label) =>
      tempData.find((item) => item.label === label)?.value;

    const nameValue = getValue("Name");
    if (!nameValue || !String(nameValue).trim()) {
      errors.Name = "School name is required.";
    }

    const capacityValue = getValue("Capacity");
    const capacityNumber = Number(capacityValue);
    if (
      !capacityValue ||
      !Number.isInteger(capacityNumber) ||
      capacityNumber <= 0
    ) {
      errors.Capacity = "Capacity must be a positive integer.";
    }

    const phoneValue = getValue("Phone");
    if (!phoneValue || !String(phoneValue).trim()) {
      errors.Phone = "Phone number is required.";
    } else if (!phoneRegex.test(String(phoneValue).trim())) {
      errors.Phone = "Phone number must be 7-15 digits (optional +).";
    }

    const countryValue = getValue("Country");
    if (!countryValue) {
      errors.Country = "Country is required.";
    }

    const programTypeValue = getValue("Program Type");
    if (!programTypeValue) {
      errors["Program Type"] = "Program type is required.";
    }

    return errors;
  };

  const handleSaveClick = () => {
    const validationErrors = validateSchoolFields();
    if (Object.keys(validationErrors).length > 0) {
      setFieldErrors(validationErrors);
      return;
    }
    setFieldErrors({});

    const diff = getDifferences();

    if (diff.Parents) {
      diff.Parents = diff.Parents.filter((id) => id && id !== -1);
    }

    updateData(diff);
    setData(tempData);
    setIsEditing(false);
  };
 
  const updateData = async (diff) => {
    if (handleEdit) {
      handleEdit(diff);
    } else {
      try {
        setLoading(true);
        setError(null);
        const url =
          type === "student"
            ? API_URLS.getStudent(id)
            : API_URLS.getStaffDetails(id);
        const response = await axiosPrivate.patch(url, diff, {
          headers: { "Content-Type": "application/json" },
        });
        console.log("Patch success", response);
        if (onSaveSuccess) {
        await onSaveSuccess();
      }
      } catch (err) {
        console.error("Patch error", err);
        setError("Failed to update. Please try again.");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleEditClick = () => {
    setTempData(data);
    setFieldErrors({});
    setIsEditing(true);
  };

  // const handleSaveClick = () => {
  //   const diff = getDifferences();
  //   updateData(diff);
  //   setData(tempData);
  //   setIsEditing(false);
  // };

  const handleCancelClick = () => {
    setFieldErrors({});
    setIsEditing(false);
  };

  const handleInputChange = (index, value) => {
    const updated = [...tempData];
    updated[index] = { ...updated[index], value };
    setTempData(updated);
    setFieldErrors((prev) => {
      const label = updated[index].label;
      if (!prev[label]) return prev;
      const next = { ...prev };
      delete next[label];
      return next;
    });
  };

  const handleParentAdded = async (id) => {
    try {
      console.log("handleparentadded");
      const response = await axiosPrivate.get(
        API_URLS.getParents(auth.id, school.id)
      );
      const parents = response.data.map((p) => ({
        id: p.id,
        name: `${p.FirstName} ${p.LastName ?? ""}`.trim(),
        email: p.email,
      }));
      const updated = [...tempData];
      const idx = updated.findIndex((item) => item.label === "Parents");

      if (idx !== -1) {
        const item = { ...updated[idx] };
        item.options = parents;

        const current = item.value;

        const available = parents.find((p) => p.id === id);

        if (available) {
          const newValues = [...current];
          const emptyIndex = newValues.findIndex((v) => v === -1);
          if (emptyIndex !== -1) {
            newValues[emptyIndex] = available.id;
          } else if (newValues.length >= 1) {
            newValues[1] = available.id;
          } else {
            newValues[0] = available.id;
          }
          item.value = newValues;
        }

        updated[idx] = item;
        setTempData(updated);
        setData(updated);
      }
    } catch (error) {
      console.error("Failed to fetch parents:", error);
    }
  };

  const handleParentSaved = async () => {
    try {
      const response = await axiosPrivate.get(
        API_URLS.getParents(auth.id, school.id)
      );
      const parents = response.data.map((p) => ({
        id: p.id,
        name: `${p.FirstName} ${p.LastName ?? ""}`.trim(),
      }));

      const updated = [...tempData];
      const idx = updated.findIndex((item) => item.label === "Parents");
      if (idx !== -1) {
        updated[idx] = {
          ...updated[idx],
          options: parents,
        };
      }
      setTempData(updated);
      setData(updated);
    } catch (error) {
      console.error("Failed to refresh parents:", error);
    }
  };



  const handleResendInvitation = async (parentId) => {
    setLoading(true);
    try {
      
      const url = API_URLS.resendParentInvitation(parentId);
      
      const response = await axiosPrivate.post(url);
      toast.success(isAr ? "تم إعادة إرسال الدعوة بنجاح" : "Invitation resent successfully!");
      
    } catch (err) {
      toast.error(isAr ? "عذراً، فشل إرسال الدعوة" : "Failed to resend invitation");
    } finally {
      setLoading(false);
    }
};

  return (
    <Box className="info-card">
      <Box className="info-card-header">
        <Typography variant="header">
          {t(`studentDetails.infoCard.titles.${title}`)}
        </Typography>
        {!isEditing && editable && (
          <Button
            onClick={handleEditClick}
            className="info-card-edit-btn"
            disabled={loading}
          >
            {t("actions.edit")}
          </Button>
        )}
        {isEditing && (
          <Box style={{ display: "flex", gap: 8 }}>
            <Button
              onClick={handleSaveClick}
              className="info-card-save-btn"
              disabled={loading}
            >
              {t("actions.save")}
            </Button>
            <Button
              onClick={handleCancelClick}
              className="info-card-cancel-btn"
              disabled={loading}
            >
              {t("actions.cancel")}
            </Button>
          </Box>
        )}
      </Box>

      <Box className="info-card-content">
        {data.map((item, idx) => (
          <Box key={idx} className="info-row">
            <Box className="info-label">
              {t(`studentDetails.infoCard.fields.${item.label}`)}
            </Box>
            {isEditing && item.editable ? (
              item.type === "multi-select" ? (
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 8,
                    width: "100%",
                  }}
                >
                  {Array.from({
                    length: Math.max(2, tempData[idx].value.length),
                  }).map((_, i) => {
                    const parentId = tempData[idx].value[i] ?? "";
                    const selectedParent = item.options?.find(opt => opt.id === parentId) || null;

                    return (
                      <Box
                        key={i}
                        style={{
                          display: "flex",
                          gap: 8,
                          alignItems: "center",
                        }}
                      >
                        <Autocomplete
                            fullWidth
                            size="small"
                            options={item.options || []}
                            
                            getOptionLabel={(option) => option.name || ""}
                            
                            value={item.options?.find(opt => opt.id === parentId) || null}
                            
                            onChange={(e, newValue) => {
                              const updated = [...tempData[idx].value];
                              updated[i] = newValue ? newValue.id : -1;
                              handleInputChange(idx, updated);
                            }}

                            renderOption={(props, option) => (
                              
                              <li {...props} key={option.id}>
                                <Box display="flex" flexDirection="column">
                                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                    {option.name}
                                  </Typography>
                                  {option.email && (
                                    <Typography 
                                      variant="caption" 
                                      sx={{ color: "gray", fontSize: "0.75rem" }}
                                    >
                                      {option.email}
                                    </Typography>
                                  )}
                                </Box>
                              </li>
                            )}

                            filterOptions={(options, { inputValue }) => {
                              const term = inputValue.toLowerCase();
                              return options.filter(opt => 
                                opt.name.toLowerCase().includes(term) || 
                                (opt.email && opt.email.toLowerCase().includes(term))
                              );
                            }}

                            renderInput={(params) => (
                              <TextField 
                                {...params} 
                                placeholder={isAr ? "-- اختر ولي الأمر --" : "-- Select Parent --"}
                                className="info-select"
                              />
                            )}
                          />
                        {parentId !== -1 && parentId !== "" && (
                          <Box sx={{ display: "flex", gap: 1 }}>
                            <Button
                              variant="outlined"
                              size="small"
                              onClick={() => {
                                const parentData = item.options.find(
                                  (opt) => opt.id === parentId
                                );
                                setParentModalData({
                                  parent: parentData,
                                });
                                setModalMode("edit");
                                setParentModalOpen(true);
                              }}
                            >
                              {isAr ? "تعديل" : "Edit"}
                            </Button>
                            <Button
                              variant="outlined"
                              size="small"
                              color="error"
                              onClick={async () => {
                                try {
                                  // 1. Update frontend state
                                  const updated = [...tempData];
                                  const parentItem = updated.find(
                                    (item) => item.label === "Parents"
                                  );
                                  if (!parentItem) return;

                                  // Remove the selected parent
                                  const newValues = parentItem.value.filter((val) => val !== parentId);
                                  const newOptions = parentItem.options.filter((val) => val.id !== parentId);
                                  console.log("parent item", parentItem)
                                  console.log("parent id", parentId)
                                  console.log("newvalues", newValues)
                                  console.log("new options", newOptions)
                                  parentItem.value = newValues;
                                  parentItem.options = newOptions;
                                  setTempData(updated);
                                  setData(updated);

                                  // 2. Send updated parents list to backend
                                  await axiosPrivate.delete(
                                    `${API_URLS.parent}/${parentId}`
                                  );
                                  // const payload = {
                                  //   Parents: newValues.filter((p) => p !== -1),
                                  // };
                                  // await axiosPrivate.patch(
                                  //   API_URLS.getStudent(id),
                                  //   payload,
                                  //   {
                                  //     headers: {
                                  //       "Content-Type": "application/json",
                                  //     },
                                  //   }
                                  // );

                                  console.log("Parent deleted successfully");
                                } catch (err) {
                                  console.error(
                                    "Failed to delete parent:",
                                    err
                                  );
                                  setError(
                                    "Failed to delete parent. Please try again."
                                  );
                                }
                              }}
                            >
                              {isAr ? "حذف" : "Delete"}
                            </Button>
                          </Box>
                        )}
                      </Box>
                    );
                  })}
                </Box>
              ) : item.type === "select" ? (
                <FormControl
                  fullWidth
                  size="small"
                  error={Boolean(fieldErrors[item.label])}
                >
                  <Select
                    value={tempData[idx].value}
                    onChange={(e) => handleInputChange(idx, e.target.value)}
                    className="info-select"
                  >
                    {item.options?.map((opt) => (
                      <MenuItem key={opt.id} value={opt.id}>
                        {item.label === "Country" 
                          ? t(`countries.${opt.id}`, { defaultValue: opt.name }) 
                          : item.label === "Nationality"
                            ? (isAr ? opt.Name_ar : opt.name) 
                            : t(`options.${opt.name}`, { defaultValue: opt.name })}
                      </MenuItem>

                    ))}
                  </Select>
                  {fieldErrors[item.label] && (
                    <FormHelperText>{fieldErrors[item.label]}</FormHelperText>
                  )}
                </FormControl>
              ) : item.type === "date" ? (
                <TextField
                  size="small"
                  type="date"
                  value={tempData[idx].value}
                  onChange={(e) => handleInputChange(idx, e.target.value)}
                  fullWidth
                  className="info-text-field"
                  error={Boolean(fieldErrors[item.label])}
                  helperText={fieldErrors[item.label]}
                  InputProps={{
                    style: { fontSize: 14 },
                  }}
                />
              ) : (
                <TextField
                  size="small"
                  value={tempData[idx].value}
                  onChange={(e) => handleInputChange(idx, e.target.value)}
                  type={item.label === "Capacity" ? "number" : item.label === "Phone" ? "tel" : "text"}
                  fullWidth
                  className="info-text-field"
                  inputProps={
                    item.label === "Capacity" ? { min: 1, step: 1 } : undefined
                  }
                  error={Boolean(fieldErrors[item.label])}
                  helperText={fieldErrors[item.label]}
                  InputProps={{
                    style: { fontSize: 14 },
                  }}
                />
              )
            ) : (
              <Box className="info-value">
              {item.type === "multi-select" ? (
                    <Box 
                      sx={{ 
                        display: "flex", 
                        flexDirection: "column", 
                        alignItems: "flex-end", 
                        gap: 1,
                        [isAr ? "marginRight" : "marginLeft"]: "auto" 
                      }}
                    >
                      {item.options
                        ?.filter((opt) => item.value.includes(opt.id))
                        .map((opt) => (
                          <Box 
                            key={opt.id} 
                            sx={{ 
                              display: "flex", 
                              alignItems: "center", 
                              gap: 1,
                              flexDirection: isAr ? "row-reverse" : "row" 
                            }}
                          >
                            <Typography sx={{ fontSize: 14, whiteSpace: "nowrap" }}>
                              {type === "student" && item.label === "Parents"
                                ? opt.name
                                : t(`options.${opt.name}`, { defaultValue: opt.name })}
                            </Typography>

                            {item.label === "Parents" && (
                              <Button
                                size="small"
                                variant="outlined"
                                onClick={() => handleResendInvitation(opt.id)}
                                disabled={loading}
                                sx={{
                                  fontSize: "10px",
                                  textTransform: "none",
                                  color: "#702E8F",
                                  borderColor: "#702E8F",
                                  minWidth: "auto",
                                  padding: "0px 6px",
                                  height: "22px",
                                  "&:hover": { backgroundColor: "rgba(112, 46, 143, 0.04)", borderColor: "#702E8F" },
                                }}
                              >
                                {isAr ? "اعادة إرسال الدعوة" : "Resend Invitation"}
                              </Button>
                            )}
                          </Box>
                        )) || "---"}
                    </Box>
                  ) 
                      : item.type === "select"
                      ? (() => {
                        if (item.label === "Nationality") {
                            if (typeof item.value === 'object' && item.value !== null) {
                              return item.value.Name_ar || item.value.Name || "---";
                            }
                            const selectedOpt = item.options?.find((opt) => opt.id === item.value);
                            return selectedOpt ? (isAr ? (selectedOpt.Name_ar || selectedOpt.name) : selectedOpt.name) : "---";
                          }

                          const currentVal = typeof item.value === 'object' ? item.value?.code : item.value;
                          const selectedOpt = item.options?.find((opt) => opt.id === currentVal);

                          if (item.label === "Country") {
                            const translated = t(`countries.${currentVal}`);
                            return translated !== `countries.${currentVal}` ? translated : (selectedOpt?.name || currentVal);
                          }

                          return selectedOpt ? t(`options.${selectedOpt.name}`, { defaultValue: selectedOpt.name }) : "---";
                        })()
                : item.value || "---"}
            </Box>
            )}
            {item.type === "multi-select" && isEditing && item.editable && (
              <>
                <Button
                  onClick={() => setShowModal(true)}
                  sx={{
                    color: "#702E8F",
                    width: "9rem",
                    fontWeight: 600,
                    fontSize: "medium",
                    textTransform: "none",
                  }}
                >
                  + {t("parent_modal.title")}
                </Button>
                <ParentModal
                  open={showModal}
                  onClose={() => setShowModal(false)}
                  data={item.modalData}
                  onParentSaved={handleParentAdded}
                />
              </>
            )}
          </Box>
        ))}
        {parentModalOpen && (
          <ParentModal
            open={parentModalOpen}
            onClose={() => setParentModalOpen(false)}
            data={parentModalData}
            mode={modalMode}
            onParentSaved={handleParentSaved}
          />
        )}

        {error && (
          <Typography variant="body2" color="error" sx={{ mt: 2 }}>
            {error}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default InfoCard;
